import { render, staticRenderFns } from "./TestScene.vue?vue&type=template&id=84f7a4ee&scoped=true"
import script from "./TestScene.vue?vue&type=script&lang=js"
export * from "./TestScene.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f7a4ee",
  null
  
)

export default component.exports